import React from 'react';

const NotFoundPage: React.FC = () => {
  return <div>NOT FOUND</div>;
};

export default NotFoundPage;
